import React from 'react'
import { Carousel as BCarousel } from 'react-bootstrap'
import { StyledCarouselItem, ItemContainer, CarouselWrapper, StyledIndicatorsList, StyledIndicatorsItem} from './styled'
import classnames from 'classnames'

const Carousel = (props) => {

    const [activeIndex, setActiveIndex] = React.useState(0)

    const goToIndex = (index) => {
        setActiveIndex(index)
    }

    React.useEffect(() => {
        const total = props.slides.length - 1
        console.log(total)
        setInterval(() => {
            setActiveIndex((prev) => {
                if(prev === total) {
                    return 0
                }else {
                    return prev + 1
                }
            })
            
        },4000)
    }, [props])

    return (
        <CarouselWrapper margin={props?.margin}>
            <ItemContainer>
                <h2 style={{textTransform: 'uppercase'}}>{props.slides[0]?.title}</h2>
                <p>{props.slides[0]?.content}</p>
            </ItemContainer>
            <BCarousel interval={5000} controls={false} indicators={false} activeIndex={activeIndex}>
                {
                    props?.slides?.map((slide, index) => (
                        <StyledCarouselItem key={index}>
                            <img src={slide?.image.url} alt={slide?.image.alt}/>
                            
                        </StyledCarouselItem>  
                    ))
                }
            </BCarousel>

            <StyledIndicatorsList className='carousel-indicators'></StyledIndicatorsList>
                {
                    props?.slides?.length > 1 
                    ? (
                        <StyledIndicatorsList className='carousel-indicators'>
                            {
                                props?.slides?.map((item, index) => (
                                    <StyledIndicatorsItem key={index} onClick={() => goToIndex(index)} className={classnames({ active: index === activeIndex })}/>
                                ))
                            }
                        </StyledIndicatorsList>
                    )
                    : ''
                }
                
        </CarouselWrapper>
    )
}

export default Carousel